const escapeText = value => String(value).replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));

export function renderInlineMarkdown (text, depth = 0) {
  if (depth >= 8) return escapeText(text);
  const pattern = /\*\*\*(?=\S)(.+?)(?<=\S)\*\*\*|\*\*(?=\S)(.+?)(?<=\S)\*\*|~~(?=\S)(.+?)(?<=\S)~~|(?<!\*)\*(?!\*)(?=\S)(.+?)(?<=\S)\*(?!\*)/g;
  let result = '', offset = 0, match;
  while ((match = pattern.exec(text))) {
    result += escapeText(text.slice(offset, match.index));
    const tag = match[2] ? 'strong' : match[3] ? 'del' : 'em';
    const inner = renderInlineMarkdown(match[1] || match[2] || match[3] || match[4], depth + 1);
    result += match[1] ? `<strong><em>${inner}</em></strong>` : `<${tag}>${inner}</${tag}>`;
    offset = pattern.lastIndex;
  }
  return result + escapeText(text.slice(offset));
}

export function toggleInlineMarkdown (text, start, end, marker) {
  const before = text.slice(0, start), selected = text.slice(start, end), after = text.slice(end);
  if (before.endsWith(marker) && after.startsWith(marker)) {
    return { text: before.slice(0, -marker.length) + selected + after.slice(marker.length), start: start - marker.length, end: end - marker.length };
  }
  if (selected.length >= marker.length * 2 && selected.startsWith(marker) && selected.endsWith(marker)) {
    return { text: before + selected.slice(marker.length, -marker.length) + after, start, end: end - marker.length * 2 };
  }
  return { text: before + marker + selected + marker + after, start: start + marker.length, end: end + marker.length };
}
